module.exports = __webpack_public_path__ + "themes/mf/img/button-hover@2x.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/button-hover@2x.png
// module id = 28
// module chunks = 3